module.exports = __webpack_public_path__ + "img/itx-text-h3.c816c56d.svg";